<script>
import appConfig from '@src/app.config'
import '@fontsource/roboto'

export default {
  page: {
    // All subcomponent titles will be injected into this template.
    titleTemplate(title) {
      title = typeof title === 'function' ? title(this.$store) : title
      return title ? `${title} | ${appConfig.title}` : appConfig.title
    },
  },
}
</script>

<template>
  <div id="app">
    <!--
    Even when routes use the same component, treat them
    as distinct and create the component again.
    -->
    <RouterView :key="$route.fullPath" />
  </div>
</template>

<!-- This should generally be the only global CSS in the app. -->
<style lang="scss">
@import '~nprogress/nprogress.css';
@import '~vue-multiselect/dist/vue-multiselect.min.css';
@import '~shepherd.js/dist/css/shepherd.css';

// Design variables and utilities from src/design.
@import '@design';
@import 'app';

*,
*::before,
*::after {
  box-sizing: border-box;
}

body {
  @media (min-width: $lg-breakpoint) {
    padding-right: 0 !important;
    overflow-y: scroll;
  }

  margin-right: calc(-1 * (100vw - 100%));
  overflow-x: hidden;
  scrollbar-gutter: stable;
  background: $color-body-bg;
}

body.login {
  background: $primary-blue;
}

body.iframe {
  overflow-y: hidden;
}

// ===
// Vendor
// ===
#nprogress .bar {
  background: $primary-blue;
}
</style>
